import { Landmark } from 'lucide-react';
import { roleLabel } from '../../../utils/permissions';
import { NAME_PENDING } from '../../../utils/constants';
import { useAuth } from '../../../AuthContext';
import usePartnerDetails from '../../../hooks/usePartnerDetails';
import PageHeader from '../../shell/PageHeader';
import { Card, Alert, DetailRow, EmptyState } from '../../ui';

const BusinessInfo = () => {
  const { role } = useAuth();
  const { details, loading, error, setError } = usePartnerDetails();

  // The details endpoint omits any field the caller lacks permission to see, while a
  // present-but-null field means "not set yet" — so visibility tests `in`, never truthiness.
  const canSeeBank = 'account_number' in details;

  return (
    <>
      <PageHeader
        title="Business info"
        breadcrumbs={[{ label: 'Home', to: '/layout' }, { label: 'Business info' }]}
        actions={<span className="badge bg-primary-500/10 text-primary-500">{roleLabel(role)}</span>}
      />

      {error && (
        <Alert variant="danger" className="mb-6" onDismiss={() => setError('')}>
          {error}
        </Alert>
      )}

      <Card title="Contact details">
        <DetailRow label="Name" loading={loading} value={details.name} />
        <DetailRow label="Email" loading={loading} value={details.email} />
        <DetailRow label="Phone" loading={loading} value={details.phone_number} />
      </Card>

      {canSeeBank && (
        <Card title="Payout account">
          {details.account_number ? (
            <>
              <DetailRow label="Account name" loading={loading} value={details.bank_account_name ?? NAME_PENDING} />
              <DetailRow label="Account number" loading={loading} value={details.account_number} />
              <DetailRow label="Bank code" loading={loading} value={details.bank_code} />
            </>
          ) : (
            <EmptyState
              icon={<Landmark className="h-8 w-8" aria-hidden="true" />}
              title="No payout account"
              message="Payouts cannot be settled until an account is linked. Contact CashAfrica support to add one."
            />
          )}
        </Card>
      )}
    </>
  );
};

export default BusinessInfo;
